export enum SmartLockInternalState {
    Unknown,
    QAMode,
    FactoryMode,
    FieldActive,
}
